import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { preferences } from '@/configuration/pages/ConfigurationPage/constants'

import { shouldRenderExchangeRecommendationSelector } from '../ExchangeRecommendationTypeSelector/helpers'
import { taxonomyDisplayValues } from './constants'
import {
  getExchangeTaxonomyIdsLabelByDisplayAndType,
  getExchangeTaxonomyIdsOptionsByTaxonomyType,
  getTaxonomyDisplayOptions,
} from './helpers'

const TaxonomyFilterConfiguration = ({
  allowedPreferences,
  provider,
  configurationPreferences,
  allowedExchangeMethods,
  externalConnectedGateway,
  taxonomyType,
  taxonomyDisplay,
  onChangeTaxonomyDisplay,
  productCategories,
  productCollections,
  productTypes,
  taxonomyIds = [],
  setTaxonomyIds,
  disabled,
}) => {
  const { t } = useTranslation()

  if (
    !allowedPreferences.includes(preferences.allowedExchangeMethods) ||
    !shouldRenderExchangeRecommendationSelector({
      provider,
      configurationPreferences,
      allowedPreferences,
      allowedExchangeMethods,
      externalConnectedGateway,
    })
  ) {
    return null
  }

  return (
    <>
      <ComboBox
        label={t('Mostrar')}
        menuItems={getTaxonomyDisplayOptions(taxonomyType, t)}
        value={taxonomyDisplay}
        handleChange={e => onChangeTaxonomyDisplay(e.target.value)}
        fullWidth
        disabled={disabled}
      />
      {taxonomyDisplay !== taxonomyDisplayValues.all && (
        <ComboBox
          label={getExchangeTaxonomyIdsLabelByDisplayAndType(taxonomyDisplay, taxonomyType, t)}
          menuItems={getExchangeTaxonomyIdsOptionsByTaxonomyType({
            type: taxonomyType,
            productCategories,
            productCollections,
            productTypes,
          })}
          multiple={true}
          value={taxonomyIds}
          handleChange={e => setTaxonomyIds(e.target.value)}
          fullWidth
          disabled={disabled}
        />
      )}
    </>
  )
}

export default TaxonomyFilterConfiguration
